import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

export interface IPlatformService {
  isBrowser: boolean;
  isServer: boolean;
}
export class PlatformService implements IPlatformService {
/**
 * @param {?} platformId
 */
constructor(
private platformId: any) {}
/**
 * @return {?}
 */
public get isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }
/**
 * @return {?}
 */
public get isServer(): boolean {
    return isPlatformServer(this.platformId);
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID, ] }, ]},
];
}

function PlatformService_tsickle_Closure_declarations() {
/** @type {?} */
PlatformService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PlatformService.ctorParameters;
/** @type {?} */
PlatformService.prototype.platformId;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
